// Calendar provider identifiers — part of the OAuth initiate URL surface.
export type CalendarProvider = "google" | "outlook";

export const CALENDAR_PROVIDERS = {
	GOOGLE: "google",
	OUTLOOK: "outlook",
} as const;

export const CALENDAR_PROVIDER_DISPLAY_NAMES: Record<CalendarProvider, string> = {
	google: "Google Calendar",
	outlook: "Outlook Calendar",
};
